import getGraphQlClient from '~graphql/getGraphQlClient';
import { onErrorShowMessage } from '~src/errors';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import { FETCH_CATEGORIE_SERVIZI } from '../queries/categorieServizi';

export const fetchProcuctCategories = async (where = {}, limit = 100) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      variables: { where, limit },
      query: FETCH_CATEGORIE_SERVIZI,
    });
    return await unmarshalGraphqlResponse(response.data, 'categorie_servizis')
      .edges;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
